
import React, { useEffect } from "react";
import {
  JOIN_ROOM,
  ADMIN_SEND_MESSAGE_EVENT,
  ADMIN_EVENTS_LISTING_LISTENER,
  ADMIN_EVENTS_LISTING_EVENT,
  ADMIN_GET_USER_CHAT_EVENT,
  ADMIN_GET_USER_CHAT_LIST_LISTENER,
  ADMIN_GET_USER_MESSAGE_LISTENER,
  ADMIN_JOINED_USER_ROOM_LISTENER,
} from "./eventconst.ts";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";

export const ChatContext = React.createContext({});

const ChatProvider = (props) => {
  const params = new URLSearchParams(window.location.search);
  const userId = params.get("user_id") || "";
  const eventid = params.get("event_id") || "";

  const adminToken = sessionStorage.getItem("adminToken");
  const connectionUrl = process.env.REACT_APP_SOCKET_URL;

  console.log('------connectionUrl', connectionUrl)

  const [messages, setMessages] = React.useState([]);
  const [events, setEvents] = React.useState({ data: [], total_count: 0 });
  const [connectionId, setConnectionId] = React.useState(userId || "");
  const [eventId, setEventId] = React.useState(eventid || "");
  const socketRef = React.useRef();
  const [messageLoad, setMessageLoad] = React.useState(false);
  const [socketConnect, setSocketConnect] = React.useState(false);
  const socketConnectRef = React.useRef(0);
  const messagePageRef = React.useRef(0);
  const messageBottomRef = React.useRef();
  const ChatScrollRef = React.useRef();
  const connectionIdRef = React.useRef("");
  const eventsRef = React.useRef([]);
  const [unreadCount, setUnreadCount] = React.useState(0);
  const processedMessagesRef = React.useRef(new Set());
  const sentTempIdsRef = React.useRef(new Set());

  const getInfo = useSelector((e) => e.userAuth.adminDetail);
  const [, forceUpdate] = React.useState();



  const getEventsList = (eventsData) => {
    setEvents((events) => {
      return {
        ...events,
        data: eventsData.events,
      };
    });
    eventsRef.current = eventsData.events;

    const totalUnread = eventsData.events.reduce(
      (sum, event) => sum + (event.isUnRead || 0),
      0
    );
    setUnreadCount(totalUnread);
  };

  const getMessage = (messageRes) => {
    if (messageRes._tempId && sentTempIdsRef.current.has(messageRes._tempId)) {
      setMessages((prevMessages) => {
        const existingIndex = prevMessages.findIndex(
          (msg) => msg._tempId === messageRes._tempId
        );

        if (existingIndex === -1) {
          return prevMessages;
        }

        const updatedMessages = [...prevMessages];
        updatedMessages[existingIndex] = messageRes;
        return updatedMessages;
      });
      sentTempIdsRef.current.delete(messageRes._tempId);

      return;
    }

    if (messageRes.sender?._id === getInfo?._id) {
      return;
    }

    // Prevent duplicate processing of same message
    if (processedMessagesRef.current.has(messageRes._id)) {
      return;
    }
    processedMessagesRef.current.add(messageRes._id);

    const params = new URLSearchParams(window.location.search);
    const currentEventId = params.get("event_id") || "";
    const messageEventId = messageRes.event?._id || messageRes.event;

    // Update unread counts and move event to top
    let filteredData = [...eventsRef.current];
    let index = filteredData.findIndex((res) => res?._id === messageEventId);

    if (index !== -1) {
      const eventToMove = filteredData[index];
      
      if (currentEventId !== messageEventId) {
        eventToMove.isUnRead = (eventToMove.isUnRead || 0) + 1;
        setUnreadCount((prev) => prev + 1);
      } else {
        eventToMove.isUnRead = 0;
      }

      // New Added start
      // Update lastMessage
      eventToMove.lastMessage = {
        text: messageRes.message,
        time: messageRes.createdAt,
        sender: {
          ...messageRes.sender,
          fullName: messageRes.sender?.fullName || messageRes.sender?.name || 'Client'
        }
      };

      // New Added End

      // Move event to top if not already there
      if (index > 0) {
        filteredData.splice(index, 1);
        filteredData.unshift(eventToMove);
        eventsRef.current = filteredData;
      }

      setEvents({
        ...events,
        data: filteredData,
      });
    }

    //     setMessages((prevMessages) => {
    //   const exists = prevMessages.some(
    //     (msg) =>
    //       msg._id === messageRes._id ||
    //       (msg._tempId && msg._tempId === messageRes._tempId)
    //   );

    //   if (exists) {
    //     return prevMessages.map((msg) =>
    //       msg._tempId === messageRes._tempId ? messageRes : msg
    //     );
    //   }

    //   return [...prevMessages, messageRes];
    // });

    setMessages((prevMessages) => {
      const existingIndex = prevMessages.findIndex(
        (msg) =>
          msg._id === messageRes._id ||
          (msg._tempId && msg._tempId === messageRes._tempId)
      );

      if (existingIndex !== -1) {
        const updatedMessages = [...prevMessages];
        updatedMessages[existingIndex] = messageRes;
        return updatedMessages;
      }

      return [...prevMessages, messageRes];
    });

    if (currentEventId === messageEventId) {
      setTimeout(() => {
        messageBottomRef.current?.scrollIntoView({
          behavior: "smooth",
        });
      }, 200);
    }
  };

  const getMessageList = (messages) => {

    const params = new URLSearchParams(window.location.search);
    const eventid = params.get("event_id") || "";

    setMessages(messages);
    let filteredData = eventsRef.current;
    let index = filteredData.findIndex((res) => res?._id === eventid);
    if (index !== -1) {
      filteredData[index].isUnRead = 0;
      setEvents((events) => {
        return {
          ...events,
          data: filteredData,
        };
      });
    }
    setTimeout(() => {
      messageBottomRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    }, 200);
  };

  // const sendMessage = (messageBody) => {
  //     if (!socketRef.current?.connected) return 'Please connect chat';
  //     socketRef.current?.emit(ADMIN_SEND_MESSAGE_EVENT, messageBody);
  //     return 'Message sent'
  // };

  const sendMessage = (messageBody) => {
    if (!socketRef.current?.connected) return "Please connect chat";

    // Move current event to top when sending message and update lastMessage
    let filteredData = [...eventsRef.current];
    let index = filteredData.findIndex((res) => res?._id === messageBody.event);
    if (index !== -1) {
      const eventToMove = filteredData[index];

      // Update lastMessage for sent message
      eventToMove.lastMessage = {
        text: messageBody.message,
        time: new Date().toISOString(),
        sender: {
          _id: getInfo?._id || "",
          fullName: getInfo?.fullName || eventToMove?.musician?.fullName || "Bianca",
          role: sessionStorage.getItem("role"),
        }
      };

      if (index > 0) {
        filteredData.splice(index, 1);
        filteredData.unshift(eventToMove);
      }

      eventsRef.current = filteredData;
      setEvents(prev => ({ ...prev, data: filteredData }));
    }

    const now = new Date().toISOString();
    if (messageBody._tempId) {
      sentTempIdsRef.current.add(messageBody._tempId);
    }

    const localMsg = {
      _id: messageBody._tempId || `temp-${Date.now()}`,
      message: messageBody.message,
      receiver: { _id: messageBody.receiver },
      event: messageBody.event,
      createdAt: now,
      sender: messageBody._localSender || {
        _id: getInfo?._id || "",
        role: sessionStorage.getItem("role"),
      },
      _optimistic: true,
    };

    setMessages((prev) => [...prev, localMsg]);

    setTimeout(() => {
      messageBottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 50);

    socketRef.current?.emit(ADMIN_SEND_MESSAGE_EVENT, {
      message: messageBody.message,
      receiver: messageBody.receiver,
      event: messageBody.event,
      _tempId: messageBody._tempId,
    });

    return "Message sent";
  };

  const roomListened = (data) => {};

  // Socket listeners are registered once per socket and call through this ref,
  // so they always use the latest handlers and survive reconnects
  const handlersRef = React.useRef({});
  handlersRef.current = { getEventsList, getMessageList, getMessage, roomListened };

  const createConnection = (receiver, event) => {
    setConnectionId("");
    setEventId("");
    setMessages([]);
    messagePageRef.current = 0;
    
    // Reset unread count for the opened chat
    let filteredData = [...eventsRef.current];
    let index = filteredData.findIndex((res) => res?._id === event);
    if (index !== -1) {
      const previousUnread = filteredData[index].isUnRead || 0;
      filteredData[index].isUnRead = 0;
      setUnreadCount((prev) => Math.max(0, prev - previousUnread));
      
      setEvents((events) => ({
        ...events,
        data: filteredData,
      }));
    }
    
    let data = { receiver, event };
    socketRef.current?.emit(JOIN_ROOM, data);
    socketRef.current?.emit(ADMIN_GET_USER_CHAT_EVENT, data);
  };

  React.useEffect(() => {
    if (!adminToken) {
      setSocketConnect(false);
      return;
    }

    socketRef.current = io(connectionUrl, {
      extraHeaders: {
        auth: adminToken,
      },
    });

    const socket = socketRef.current;
    socket.on(ADMIN_EVENTS_LISTING_LISTENER, (data) => handlersRef.current.getEventsList(data));
    socket.on(ADMIN_GET_USER_CHAT_LIST_LISTENER, (data) => handlersRef.current.getMessageList(data));
    socket.on(ADMIN_GET_USER_MESSAGE_LISTENER, (data) => handlersRef.current.getMessage(data));
    socket.on(ADMIN_JOINED_USER_ROOM_LISTENER, (data) => handlersRef.current.roomListened(data));

    // After a reconnect the server has dropped us from the chat room, so
    // rejoin and reload the chat that is currently open
    const handleReconnect = () => {
      if (window.location.pathname !== "/messages") return;
      const params = new URLSearchParams(window.location.search);
      const receiver = params.get("user_id");
      const event = params.get("event_id");
      if (receiver && event) {
        socket.emit(JOIN_ROOM, { receiver, event });
        socket.emit(ADMIN_GET_USER_CHAT_EVENT, { receiver, event });
      }
    };
    socket.io.on("reconnect", handleReconnect);

    let eventsEmitTimeout;
    
    socketRef.current.on('connect', () => {
      setSocketConnect(true);
      clearTimeout(eventsEmitTimeout);
      eventsEmitTimeout = setTimeout(() => {
        let data = { search: "" };
        socketRef.current?.emit(ADMIN_EVENTS_LISTING_EVENT, data);
      }, 100);
    });
    
    socketRef.current.on('disconnect', () => {
      setSocketConnect(false);
    });

    return () => {
      clearTimeout(eventsEmitTimeout);
      socket.io.off("reconnect", handleReconnect);
      socket.removeAllListeners();
      socket.disconnect();
    };
  }, [adminToken]);
  

  React.useEffect(() => {
    if (userId && eventId && socketConnect) {
      createConnection(userId, eventId);
    }
  }, [userId, connectionId, eventId, socketConnect]);

  return (
    <ChatContext.Provider
      value={{
        messages,
        getInfo,
        socketRef,
        setEvents,
        messageBottomRef,
        messagePageRef,
        ChatScrollRef,
        events,
        setConnectionId,
        connectionId,
        setEventId,
        eventId,
        setMessages,
        createConnection,
        sendMessage,
        unreadCount,
      }}
    >
      {props.children}
    </ChatContext.Provider>
  );
};
export default ChatProvider;
























// import React, { useEffect } from "react";
// import {
//   JOIN_ROOM,
//   ADMIN_SEND_MESSAGE_EVENT,
//   ADMIN_EVENTS_LISTING_LISTENER,
//   ADMIN_EVENTS_LISTING_EVENT,
//   ADMIN_GET_USER_CHAT_EVENT,
//   ADMIN_GET_USER_CHAT_LIST_LISTENER,
//   ADMIN_GET_USER_MESSAGE_LISTENER,
//   ADMIN_JOINED_USER_ROOM_LISTENER,
// } from "./eventconst.ts";
// import { io } from "socket.io-client";
// import { useSelector } from "react-redux";

// export const ChatContext = React.createContext({});

// const ChatProvider = (props) => {
//   const params = new URLSearchParams(window.location.search);
//   const userId = params.get("user_id") || "";
//   const eventid = params.get("event_id") || "";

//   const adminToken = sessionStorage.getItem("adminToken");
//   const connectionUrl = process.env.REACT_APP_SOCKET_URL;

//   const [messages, setMessages] = React.useState([]);
//   const [events, setEvents] = React.useState({ data: [], total_count: 0 });
//   const [connectionId, setConnectionId] = React.useState(userId || "");
//   const [eventId, setEventId] = React.useState(eventid || "");
//   const socketRef = React.useRef();
//   const [messageLoad, setMessageLoad] = React.useState(false);
//   const [socketConnect, setSocketConnect] = React.useState(false);
//   const socketConnectRef = React.useRef(0);
//   const messagePageRef = React.useRef(0);
//   const messageBottomRef = React.useRef();
//   const ChatScrollRef = React.useRef();
//   const connectionIdRef = React.useRef("");
//   const listenersInitialized = React.useRef(false);
//   const eventsRef = React.useRef([]);
//   const [unreadCount, setUnreadCount] = React.useState(0);

//   const getInfo = useSelector((e) => e.userAuth.adminDetail);
//   const [, forceUpdate] = React.useState();

//   const getEventsList = (eventsData) => {
//     setEvents((events) => {
//       return {
//         ...events,
//         data: eventsData.events,
//       };
//     });
//     eventsRef.current = eventsData.events;

//     const totalUnread = eventsData.events.reduce(
//       (sum, event) => sum + (event.isUnRead || 0),
//       0
//     );
//     setUnreadCount(totalUnread);
//   };

//   const getMessage = (messageRes) => {
//     const params = new URLSearchParams(window.location.search);
//     const currentEventId = params.get("event_id") || "";
//     const messageEventId = messageRes.event?._id || messageRes.event;

//     // Update unread counts only for messages from other users
//     if (messageRes.sender?._id !== getInfo?._id) {
//       let filteredData = [...eventsRef.current];
//       let index = filteredData.findIndex((res) => res?._id === messageEventId);

//       if (index !== -1) {
//         if (currentEventId !== messageEventId) {
//           filteredData[index].isUnRead = (filteredData[index].isUnRead || 0) + 1;
//           setUnreadCount((prev) => prev + 1);
//         } else {
//           filteredData[index].isUnRead = 0;
//         }

//         setEvents({
//           ...events,
//           data: filteredData,
//         });
//       }
//     }

//     setMessages((prevMessages) => {
//       // Check for existing message by ID or tempId
//       const existingIndex = prevMessages.findIndex(
//         (msg) =>
//           msg._id === messageRes._id ||
//           (msg._tempId && msg._tempId === messageRes._tempId) ||
//           (messageRes._tempId && msg._tempId === messageRes._tempId)
//       );

//       if (existingIndex !== -1) {
//         // Replace optimistic message with real message
//         const updatedMessages = [...prevMessages];
//         updatedMessages[existingIndex] = { ...messageRes, _optimistic: false };
//         return updatedMessages;
//       }

//       // Add new message if it doesn't exist
//       return [...prevMessages, messageRes];
//     });

//     if (currentEventId === messageEventId) {
//       setTimeout(() => {
//         messageBottomRef.current?.scrollIntoView({
//           behavior: "smooth",
//         });
//       }, 200);
//     }
//   };

//   const getMessageList = (messages) => {

//     const params = new URLSearchParams(window.location.search);
//     const eventid = params.get("event_id") || "";

//     setMessages(messages);
//     let filteredData = eventsRef.current;
//     let index = filteredData.findIndex((res) => res?._id === eventid);
//     if (index !== -1) {
//       filteredData[index].isUnRead = 0;
//       setEvents((events) => {
//         return {
//           ...events,
//           data: filteredData,
//         };
//       });
//     }
//     setTimeout(() => {
//       messageBottomRef.current?.scrollIntoView({
//         behavior: "smooth",
//       });
//     }, 200);
//   };

//   // const sendMessage = (messageBody) => {
//   //     if (!socketRef.current?.connected) return 'Please connect chat';
//   //     socketRef.current?.emit(ADMIN_SEND_MESSAGE_EVENT, messageBody);
//   //     return 'Message sent'
//   // };

//   const sendMessage = (messageBody) => {
//     if (!socketRef.current?.connected) return "Please connect chat";

//     const tempId = messageBody._tempId || `temp-${Date.now()}-${Math.random()}`;
//     const now = new Date().toISOString();
//     const localMsg = {
//       _id: tempId,
//       _tempId: tempId,
//       message: messageBody.message,
//       receiver: { _id: messageBody.receiver },
//       event: messageBody.event,
//       createdAt: now,
//       sender: messageBody._localSender || {
//         _id: getInfo?._id || "",
//         role: sessionStorage.getItem("role"),
//       },
//       _optimistic: true,
//     };

//     setMessages((prev) => {
//       // Prevent duplicate optimistic messages
//       const exists = prev.some(msg => msg._tempId === tempId);
//       if (exists) return prev;
//       return [...prev, localMsg];
//     });

//     setTimeout(() => {
//       messageBottomRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, 50);

//     socketRef.current?.emit(ADMIN_SEND_MESSAGE_EVENT, {
//       message: messageBody.message,
//       receiver: messageBody.receiver,
//       event: messageBody.event,
//       _tempId: tempId,
//     });

//     return "Message sent";
//   };

//   const roomListened = (data) => {};

//   const createConnection = (receiver, event) => {
//     setConnectionId("");
//     setEventId("");
//     setMessages([]);
//     messagePageRef.current = 0;
//     let data = { receiver, event };
//     socketRef.current?.emit(JOIN_ROOM, data);
//     socketRef.current?.emit(ADMIN_GET_USER_CHAT_EVENT, data);
//   };

//   React.useEffect(() => {
//     if (!adminToken) {
//       setSocketConnect(false);
//       return;
//     }

//     socketRef.current = io(connectionUrl, {
//       extraHeaders: {
//         auth: adminToken,
//       },
//     });

//     socketConnectRef.current = setInterval(() => {
//       if (socketRef.current?.connected) {
//         setSocketConnect(true);
//         let data = { search: "" };
//         socketRef.current?.emit(ADMIN_EVENTS_LISTING_EVENT, data);
//       }
//     }, 1000);

//     return () => {
//       if (socketConnectRef.current) clearInterval(socketConnectRef.current);
//       if (socketRef.current?.connected) {
//         socketRef.current.disconnect();
//       }
//     };
//   }, [adminToken]);

//   React.useEffect(() => {
//     if (socketRef.current?.connected && !listenersInitialized.current) {
//       listenersInitialized.current = true;

//       socketRef.current.on(ADMIN_EVENTS_LISTING_LISTENER, getEventsList);
//       socketRef.current.on(ADMIN_GET_USER_CHAT_LIST_LISTENER, getMessageList);
//       socketRef.current.on(ADMIN_GET_USER_MESSAGE_LISTENER, getMessage);
//       socketRef.current.on(ADMIN_JOINED_USER_ROOM_LISTENER, roomListened);
//     }

//     return () => {
//       if (socketRef.current?.connected) {
//         socketRef.current.removeAllListeners(ADMIN_EVENTS_LISTING_LISTENER);
//         socketRef.current.removeAllListeners(ADMIN_GET_USER_CHAT_LIST_LISTENER);
//         socketRef.current.removeAllListeners(ADMIN_GET_USER_MESSAGE_LISTENER);
//         socketRef.current.removeAllListeners(ADMIN_JOINED_USER_ROOM_LISTENER);
//       }
//     };
//   }, [socketConnect, adminToken]);

//   React.useEffect(() => {
//     if (userId && eventId && socketConnect) {
//       createConnection(userId, eventId);
//     }
//   }, [userId, connectionId, eventId, socketConnect]);

//   return (
//     <ChatContext.Provider
//       value={{
//         messages,
//         getInfo,
//         socketRef,
//         setEvents,
//         messageBottomRef,
//         messagePageRef,
//         ChatScrollRef,
//         events,
//         setConnectionId,
//         connectionId,
//         setEventId,
//         eventId,
//         setMessages,
//         createConnection,
//         sendMessage,
//         unreadCount,
//       }}
//     >
//       {props.children}
//     </ChatContext.Provider>
//   );
// };
// export default ChatProvider;
